import { render, staticRenderFns } from "./public-shipment-view.vue?vue&type=template&id=0e161706&scoped=true"
import script from "./public-shipment-view.vue?vue&type=script&lang=js"
export * from "./public-shipment-view.vue?vue&type=script&lang=js"
import style0 from "./public-shipment-view.vue?vue&type=style&index=0&id=0e161706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e161706",
  null
  
)

export default component.exports